export default {
    message: {
        unopen: 'belum buka!',
    },
};